export default function ShowingFile({ values, setValues }) {
  // Handler to delete a file
  const handleDelete = (index) => {
    const newValues = values.filter((_, i) => i !== index); // Remove file at the specified index
    setValues(newValues); // Update the state
  };

  return (
    <div>
      {values.length > 0 && (
        <ul className='flex flex-col text-center' dir='rtl'>
          <p>تم رفع الملفات :</p>
          {values?.map((file, index) => (
            <li
              key={file.fileUrl}
              className='flex justify-between items-center mb-2 gap-4'
            >
              <button
                className='inline-flex items-center justify-center  px-3 py-2 text-sm font-medium text-center rounded-lg text-red-500 hover:bg-red-500 hover:text-white sm:w-auto border-2 border-red-500'
                onClick={() => handleDelete(index)}
                type='button'
              >
                حذف
              </button>

              <div>
                <a
                  className='text-blue-600'
                  href={file.fileUrl}
                  target='_blank'
                  rel='noreferrer'
                >
                  {file.fileName}
                </a>
                <img className="max-w-[10rem] rounded-lg mt-1" src={file.fileUrl} alt={file.fileUrl} />
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
